<template>
    <main class="content">
        <header class="content-header">
            <section class="content-header-section">
                <h1 class="content-header-title">{{ title }}</h1>
            </section>
            <section v-if="showNew" class="content-header-section">
                <span class="button button-blue" @click="$emit('new')">{{ $t('components.list.button_add') }}</span>
            </section>
        </header>
        <div class="content-top">
            <div class="content-top-lang" v-click-outside="langClose">
                <div class="content-top-lang-value" @click="langToggle">{{ lang }}</div>
                <ul v-if="langIsOpen" class="content-top-lang-select">
                    <li
                        v-for="language in $options.languages"
                        :key="language"
                        :class="{ selected: lang === language }"
                        @click="langClick(language)"
                    >
                        {{ language }}
                    </li>
                </ul>
            </div>
            <div class="content-top-count">{{ $t('components.list.label_count', { count }) }}</div>
        </div>
        <div class="content-data">
            <slot></slot>
        </div>
        <slot name="extras"></slot>
    </main>
</template>

<script>
import languages from '@/config/languages';

export default {
    name: 'List',
    languages,
    props: {
        title: {
            type: String,
        },
        count: {
            type: Number,
        },
        lang: {
            type: String,
        },
        showNew: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            langIsOpen: false,
        };
    },
    methods: {
        langClose() {
            this.langIsOpen = false;
        },
        langToggle() {
            this.langIsOpen = !this.langIsOpen;
        },
        langClick(language) {
            this.langIsOpen = false;
            this.$emit('language', language);
        },
    },
};
</script>
